import { mapValues, Dictionary } from 'lodash';
import { Object, Static, Boolean, String, Number, Null, Undefined } from 'runtypes';
import { Route, RouteRecord } from './utils';
import { userRoutes } from './user';
import { classRoutes } from './class';
import { classroomRoutes } from './classroom';
import { moduleRoutes } from './module';
import { externalRoutes } from './external';
import { sessionRoutes } from './session';
import { adminRoutes } from './admin';
import { mailerRoutes } from './mailer';
import { accountManagementRoutes } from './accountManagement';

export const PingResponseRecord = Object({
  commit: String,
  release: String,
  connections: Number,
  database: Boolean,
  tlsProtocol: String.or(Null),
  cookieMaxAgeHours: Number,
  nodeEnv: String.or(Null),
});
export type PingResponse = Static<typeof PingResponseRecord>;

export const routes: Dictionary<Route> = mapValues(
  {
    ping: {
      method: 'get',
      path: '/ping',
      requestBody: Undefined,
      responseData: PingResponseRecord,
    },

    ...userRoutes(),
    ...classRoutes(),
    ...classroomRoutes(),
    ...moduleRoutes(),
    ...externalRoutes(),
    ...sessionRoutes(),
    ...adminRoutes(),
    ...mailerRoutes(),
    ...accountManagementRoutes(),
  },
  (x: any): Route => {
    // RouteRecord is not complete, so we still need to cast x into Route.
    if (RouteRecord.guard(x)) return x as Route;
    throw new Error(`Route format error ${x}`);
  },
);
